module.exports = __webpack_public_path__ + "img/form-icon.9e20624b.svg";